import * as React from "react";
import { Route, Switch } from "react-router-dom";

/**
 * home
 */
import DashBoard from 'pages/dashboard';
import OrderList from "containers/OrderList";
import OrderDetails from "containers/OrderDetails";
import CustomOrderList from "containers/CustomOrderList";
import CustomOrder from "containers/CustomOrder";

const Routes: React.StatelessComponent = () => {
  return (
    <Switch>
      <Route exact path="/app/customOrderList" component={CustomOrderList} />
      <Route exact path="/app/customOrder" component={CustomOrder} />
      <Route exact path="/app/orderList" component={OrderList} />
      <Route exact path="/app/orderList/:type" component={OrderList} />
      <Route exact path="/app/orderDetails/:id" component={OrderDetails} />
      <Route exact path="/app/dashboard" component={DashBoard} />
    </Switch>
  );
};

export default Routes;
